module.exports = __webpack_public_path__ + "static/media/org3.4651e0b3.png";